import React, {Component} from 'react';
import {connect} from 'react-redux'

import {loginWithPassword} from '../actions/authActions'
import {forgotPassword} from "../actions/authActions";

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            emailError: ''
        }
        this.emailRef = React.createRef()
        this.passwordRef = React.createRef()
        this.rememberRef = React.createRef()
    }

    validateEmail = (email) => {
        if (!email) {
            return 'An email address is required to login'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            return 'Invalid email address'
        }
        return ''
    }

    handleEmailBlur = (e) => {
        const email = e.target.value
        this.setState({
            emailError: this.validateEmail(email)
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const email = this.emailRef.current.value
        const password = this.passwordRef.current.value
        const emailError = this.validateEmail(email)

        if (emailError) {
            this.setState({ emailError })
            return
        }

        this.props.onLogin(email.trim(), password)
    }

    handleResetPassword = (e) => {
        e.preventDefault()
        const email = this.emailRef.current ? this.emailRef.current.value : '';
        this.props.onForgotPassword(email.trim())
    }

    render() {
        const {
            pending,
            loginError,
            errorMessage
        } = this.props;

        const { emailError } = this.state;

        return (
            <div
                className="col-xs-8 col-sm-6 col-md-4 col-xs-offset-2 col-sm-offset-3 col-md-offset-4 shthum--auth-page-login">
                <form id="frmLogin" className="shtum--form-login" role="form"
                      onSubmit={this.handleSubmit}>

                    <div className="form-group">
                        <label htmlFor="username" className="sr-only">Email address</label>
                        <input
                            type="email"
                            className="form-control shtum--form-input"
                            id="username"
                            name="username"
                            autoComplete="username"
                            placeholder="Enter email"
                            ref={this.emailRef}
                            onBlur={this.handleEmailBlur}
                        />
                        {emailError &&
                        <div className="help-block shtum--form-error">{emailError}</div>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="password" className="sr-only">Password</label>
                        <input
                            type="password"
                            className="form-control shtum--form-input"
                            id="password"
                            name="password"
                            autoComplete="current-password"
                            placeholder="Password"
                            ref={this.passwordRef}
                        />
                        {loginError && errorMessage &&
                        <div className="help-block shtum--form-error">{errorMessage}</div>}
                    </div>

                    <div className="form-inline">
                        <div className="form-group">
                            <div className="checkbox shtum--form-login-checkbox">
                                <div className="shtum--checkbox">
                                    <input
                                        type="checkbox"
                                        id="frmLoginCheckbox"
                                        name="remember"
                                        ref={this.rememberRef}
                                    />
                                    <span/>
                                </div>
                                <label htmlFor="frmLoginCheckbox">remember me</label>
                            </div>
                        </div>
                        <div className="form-group text-right">
                            <button type="submit" className="btn shtum--btn shtum--btn_green"
                                    disabled={pending}>
                                Login
                            </button>
                        </div>
                    </div>
                    <div className="form-group text-right">
                        <a href="#" className="shtum--form-login-forgotten-link"
                           onClick={this.handleResetPassword}>forgotten password?</a>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    let auth = state.auth;
    return {
        pending: auth.pending,
        loginError: auth.error,
        errorCode: auth.errorCode,
        errorMessage: auth.errorMessage
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogin: (email, password) => {
            dispatch(loginWithPassword(email, password))
        },
        onForgotPassword: (email) =>
            dispatch(forgotPassword(email))
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);
